import {getData, postData} from "./index";
import C from "../constants";
import {userConsts} from "../constants/users";
import {changeAuthorized} from "../actions/auth";
import {addUserToStorage, removeUserFromStorage, updateUserData} from "../actions/user";
import {API_URL} from "../constants/mainApi";


const URLS = {
    REGISTRATION: `${API_URL}auth/regist`,
    LOGIN: `${API_URL}auth/login`,
    LOGOUT: `${API_URL}auth/out`,
    CHECK_SESSION: `${API_URL}auth/session`,
    SET_LOGIN: `${API_URL}/auth/oaregist`,
    SAVE_NEW_PASSWORD: `${API_URL}user/resetpsw`,

};


//Регистрация
export const registrationRequest = (userInfo = {}) => {

    return postData(URLS.REGISTRATION, userInfo)
        .then(
            (res) => {
                return res.email
            }
        ).catch(
            error => {
                return error;
            }
        );
};

//Вход
export const loginRequest = (dispatch = f => f, login, pass) => {
    return postData(URLS.LOGIN, {
        username: login,
        password: pass,
    }).then(
        data => {
            dispatch(addUserToStorage(data.user));
            dispatch(changeAuthorized(true));
            return data;
        }
    ).catch(
        err => {
            dispatch({
                type: C.FAIL_LOADING,
                user: {},
                statusLoad: userConsts.LOADING_STATUS.NOT_LOADED,
            });
            throw err;
        }
    );
};


//Выход
export const logoutRequest = (dispatch = f => f) => {

    postData(URLS.LOGOUT).then(
        () => {
            dispatch(changeAuthorized(false));
            dispatch(removeUserFromStorage());
        }
    ).catch(
        error => {
            console.log("Error " + error);
        }
    );
};


//Проверка сессии
export const checkSessionRequest = (dispatch = f => f) => {

    return postData(URLS.CHECK_SESSION).then(data => {
        dispatch(changeAuthorized(true));
        dispatch(updateUserData(data.user));
        return data;
    }).catch(
        (err) => {
            dispatch(changeAuthorized(false));
            dispatch(removeUserFromStorage());
            throw err;

        }
    );
};


//Ввод логина после регистрации через соц. сеть
export const setLoginRequest = (dispatch = f => f, login) => {

    return postData(URLS.SET_LOGIN, {
        login: login,
    }).then(
        data => {
            dispatch(addUserToStorage(data.user));
            dispatch(changeAuthorized(true));
        }
    ).catch(
        error => {
            console.log("Error: " + error.statusText);
            dispatch(changeAuthorized(false));
        }
    );
};


export const saveNewPasswordRequest = (login, pass, code) => {
    return postData(URLS.SAVE_NEW_PASSWORD, {
        login: login,
        newpassword: pass,
        code: code,
    })
};


//Проверка занятости login
export const checkAvailableLoginRequest = (login) => {
    let url = `${API_URL}auth/checklogin?login=${login}`;

    return getData(url);
};


//Проверка занятости email
export const checkAvailableEmailRequest = (email) => {
    let url = `${API_URL}auth/checkmail?email=${email}`;

    return getData(url);
};


//Востановление пароля
export const resetPasswordRequest = (username) => {
    let url = `${API_URL}user/resetpsw?username=${username}`;

    return getData(url);
};


//Повторная отправка ссылки для подтверждения почты
export const repeatEmailConfirmRequest = (username) => {
    let url = `${API_URL}auth/repeatmail?username=${username}`;

    return getData(url)
        .then(data => data)
        .catch(err => err);
};


// WEBPACK FOOTER //
// src/fetch/auth.jsx